export const FESTIVAL_IMAGES = {
  krishna: '/festivals/krishna.jpg',
  ganesh: '/festivals/ganesh.jpg',
  shiv: '/festivals/shiv.jpg',
  durga: '/festivals/durga.jpg',
  laxmi: '/festivals/laxmi.jpg',
  hanuman: '/festivals/hanuman.jpg',
  ram: '/festivals/ram.jpg',
  saraswati: '/festivals/saraswati.jpg',
  surya: '/festivals/surya.jpg',
  rakhi: '/festivals/rakhi.jpg',
  holi: '/festivals/holi.jpg',
  flag: '/festivals/flag.png',
  shubh: '/festivals/shubh.jpg',
};

export const DEITIES = [
  { value: 'krishna', label: 'Krishna ji' },
  { value: 'ganesh', label: 'Ganpati ji' },
  { value: 'shiv', label: 'Shiv ji' },
  { value: 'durga', label: 'Maa Durga' },
  { value: 'laxmi', label: 'Laxmi ji / Diya' },
  { value: 'hanuman', label: 'Hanuman ji' },
  { value: 'ram', label: 'Shri Ram' },
  { value: 'saraswati', label: 'Maa Saraswati' },
  { value: 'surya', label: 'Surya Dev' },
  { value: 'rakhi', label: 'Rakhi (bhai-behen)' },
  { value: 'holi', label: 'Holi (rang)' },
  { value: 'flag', label: 'Tiranga' },
  { value: 'shubh', label: 'Shubh (diya)' },
];

export const festivalImage = (image, deity) => image || FESTIVAL_IMAGES[deity] || FESTIVAL_IMAGES.shubh;
